import { Button, SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'
import Tooltip from 'components/Tooltip'

export const Footer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* Same reason as the AI Image footer: a shrinkable footer loses its height to
     a short mobile viewport and the Generate button ends up under the tab bar. */
  flex-shrink: 0;
  gap: 10px;
  padding-top: 8px;
  border-top: 1px solid ${COLORS.borderColor};
  padding: 20px 16px 12px;
  z-index: 1;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    background-color: ${COLORS.white};
    position: sticky;
    bottom: 0;
  }
`

export const GenerateButton = styled(Button)<{ $isPremium: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  ${premiumButtonStyles}
`

export const SpinningLoaderWrapper = styled(SpinningLoader)<{
  $isVisible: boolean
}>`
  width: 16px;
  height: 16px;
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`

export const CreditsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`

export const ReferenceResizeTooltip = styled(Tooltip)`
  max-width: 331px;
  width: 331px;
  min-height: 42px;
  border-radius: 4px;
  padding: 6px 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
`
